<template>
  <section id="view-hospitals-details" v-loading="loading">
    <div class="view-hospital-info">
      <div class="container-small-table">
        <div class="view-hospital-header">
          <div class="hospital-name" v-if="getSingleHospital">
            <h3>
              {{ this.getSingleHospital.name }}
              <span class="code"> CODE :</span>
              <span class="single-hospital-code">{{
                this.getSingleHospital.code
              }}</span>
            </h3>
          </div>
        </div>

        <div class="view-hospitals-tabs">
          <div class="view-hospitals-tabs-listing-block">
            <ul class="view-hospitals-tabs-list">
              <li>
                <router-link
                  :to="{
                    name: 'Hospital-Primary-Information',
                    query: this.$route.query,
                  }"
                  :class="getActiveClasstList('primary-information')"
                  >Primary Information</router-link
                >
              </li>

              <li>
                <router-link
                  :to="{ name: 'Branches-List', query: this.$route.query }"
                  :class="getActiveClasstList('branch')"
                  >Branches</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{
                    name: 'HospitalPhysicians',
                    query: this.$route.query,
                  }"
                  :class="getActiveClasstList('physicians')"
                  >Physicians</router-link
                >
              </li>

              <li>
                <router-link
                  :to="{
                    name: 'HospitalAccountManagers',
                    query: this.$route.query,
                  }"
                  :class="getActiveClasstList('account')"
                  >Account Managers</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{
                    name: 'LabAccountManagers',
                    query: this.$route.query,
                  }"
                  :class="getActiveClasstList('lab')"
                  >Lab Account Managers</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{ name: 'HospitalAdmins', query: this.$route.query }"
                  :class="getActiveClasstList('admin')"
                  >Ordering Facility Admins</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{ name: 'HospitalMarketers', query: this.$route.query }"
                  :class="getActiveClasstList('marketer')"
                  >Sales Reps</router-link
                >
              </li>
            </ul>
          </div>

          <div class="hospital-fields">
            <div class="tabs-content">
              <router-view :layout="layout"></router-view>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";

export default {
  data() {
    return {
      layout: "div",
      loading: false,
      hospitalInfo: {},
      status: "view",
      disableSubmitButton: false,
    };
  },
  components: {},
  mixins: [UserPermissionsHelper],
  computed: {
    ...mapGetters("hospitals", ["getSingleHospital"]),
    ...mapGetters("errors", ["getErrors", "getError"]),
    hospital_id() {
      if (this.$route.params.hospital_id) {
        return this.$route.params.hospital_id;
      }
      return null;
    },
    getActiveClasstList() {
      return (path) => {
        if (this.$route.path.indexOf(path) > -1) {
          return "router-link-exact-active";
        } else return "";
      };
    },
  },
  async mounted() {
    await this.fetchHospitalDetails(this.hospital_id);
  },
  methods: {
    async fetchHospitalDetails(hospital_id) {
      this.loading = true;
      await this.$store.dispatch("hospitals/fetchSingleHospital", hospital_id);
      this.loading = false;
      this.hospitalInfo = this.getSingleHospital;
    },

    editHospital() {
      this.$router.push({
        name: "EditHospital",
        params: { hospital_id: this.hospital_id },
      });
    },

    prepareHospitalAddData() {
      if (this.hospital_id) {
        this.hospitalInfo.id = this.hospital_id;
      }
      if (this.hospitalInfo.email) {
        this.hospitalInfo.email = this.hospitalInfo.email.toLowerCase();
      }
      return this.hospitalInfo;
    },

    goToHospitals() {
      this.status = "view";
    },
  },
};
</script>

<style lang="scss">
#view-hospitals-details {
  .view-hospital-info {
    .view-hospital-header {
      background: #ffffff;
      border: 0.633951px solid #e0e0e0;
      border-radius: 5px;
      .hospital-name {
        color: rgba(37, 33, 59, 0.8);
        h3 {
          padding: 5px 1rem;
          font-size: 16px;
          text-transform: capitalize;
          .code {
            color: #0a5da6;
            font-weight: 600;
            padding-left: 10px;
          }
          .single-hospital-code {
            color: #f24a55;
            font-weight: 600;
            padding-left: 5px;
          }
        }
      }
    }
    .view-hospitals-tabs {
      .view-hospitals-tabs-listing-block {
        margin: 15px 0 10px;

        .view-hospitals-tabs-list {
          display: flex;
          flex-wrap: wrap;
          row-gap: 1.3rem;
          li {
            a {
              background: #ffffff;
              border: 0.72px solid #dedbdb;
              border-radius: 5px;
              padding: 5px 20px;
              margin: 0 10px 0 0;
              color: #4f4f4f;
            }
            .router-link-exact-active {
              color: #ffffff;
              background: #273480;
              border: 0.5px solid #273480;
              border-radius: 5px;
              padding: 5px 20px;
            }
          }
        }
      }
      .hospital-tabs {
        .el-tabs__header {
          margin: 15px 0 10px;
        }

        .el-tabs__header .el-tabs__nav-wrap::after {
          display: none;
        }
        .el-tabs__item {
          background: #ffffff;
          border: 0.72px solid #dedbdb;
          border-radius: 5px;
          padding: 0 20px;

          color: #4f4f4f;
          margin: 5px;
        }
        .el-tabs__item:hover {
          color: #4f4f4f;
        }
        .el-tabs__item.is-active {
          color: #ffffff;
          background: #0a5da6;
          border: 0.5px solid #0a5da6;
          border-radius: 5px;
          padding: 0 20px;
        }
        .el-tabs__active-bar {
          display: none;
        }
      }
    }
    .case-creation__body {
      position: relative;
    }
    .edit-btn {
      position: absolute;
      right: 10px;
      border: none;
      z-index: 99;
      right: 15px;
      padding: 0;
      top: 0;

      background-color: transparent;
      color: #828282;
      .edit-icon {
        img {
          position: relative;
          top: 2.5px;
        }
      }
    }
  }
}
</style>
